import { z } from "zod/v4";

import { type Tuple } from "../Tuple";
import { ZSet } from "../ZSet";
import { type LinearOperatorLogic } from "./LinearOperatorLogic";
import { literalSchema } from "./schema-util";

export function from<T>(spec: FromSpec, filter: FromFilterSpec): LinearOperatorLogic<T, T, null> {
	const predicate = (row: Tuple<T>) => {
		return (
			filter.type === "read_all_rows" ||
			(filter.type === "read_self_rows" && filter.right.value === row.getOwner())
		);
	};
	return (input: ZSet<T>, state: null): [ZSet<T>, null] => {
		let output = ZSet.empty<T>();

		for (const tuple of input) {
			if (predicate(tuple.tuple)) {
				output = output.add(tuple);
			}
		}
		return [output, state];
	};
}

export const permissionClasses = z.union([
	z.literal("read_self_rows"),
	z.literal("read_all_rows"),
	z.literal("none"),
]);
export type FromFilterType = z.infer<typeof permissionClasses>;

export const fromFilterSpecSchema = z.union([
	z.object({
		type: z.literal("read_self_rows"),
		right: literalSchema,
	}),
	z.object({
		type: z.literal("read_all_rows"),
	}),
	z.object({
		type: z.literal("none"),
	}),
]);
export type FromFilterSpec = z.infer<typeof fromFilterSpecSchema>;

export const fromSpecSchema = z.object({
	type: z.literal("from"),
	sourceType: z.literal("table"),
	table: z.string(),
});
export type FromSpec = z.infer<typeof fromSpecSchema>;

export const fromSpec = (table: string): FromSpec => ({
	type: "from",
	sourceType: "table",
	table,
});
